"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var touchSupport = (('ontouchstart' in window) || (navigator['MaxTouchPoints'] > 0) || (navigator.msMaxTouchPoints > 0));
var root = jquery_1.default(document.documentElement || document);
function updateRootClass() {
    root.removeClass("touch no-touch");
    if (touchSupport) {
        root.addClass("touch");
    }
    else {
        root.addClass("no-touch");
    }
}
updateRootClass();
(function () {
    function detector(event) {
        touchSupport = "touchstart" == event.type;
        updateRootClass();
        document.removeEventListener('touchstart', detector, false);
    }
    if ('addEventListener' in document) {
        document.addEventListener('touchstart', detector, false);
        document.addEventListener('mousemove', detector, false);
    }
})();
function isTouch() {
    return touchSupport;
}
exports.isTouch = isTouch;
